import Swiper from 'swiper/dist/js/swiper.min.js';

jQuery(document).ready(function($) {
  if (!$('.competitive-edge').length) {
    return;
  }

  competitiveEdge($);
});

function competitiveEdge($) {


  $('.tabs .tab').on('click', function () {
    // make selected active
    $(this).addClass('active').siblings().removeClass('active');
    $('.tab-content').eq($(this).index()).addClass('active').siblings().removeClass('active');
    $('.tabs .indicator')[0].style.transform = 'translateX('+ ( 100 * $(this).index()) +'%)';
  });

  if ($(window).width() > 800) {
    new Swiper('.content-container', {
      slidesPerView: 'auto',
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
    });
  }

  if ($(window).width() <= 800) {
    $('.competitive-edge .tab-contents .content-container .info-card').on(
      'click',
      function () {
        $(this).toggleClass('hover');
      }
    )
  }
}



// WEBPACK FOOTER //
// ./scripts/blocks/competitive-edge.js